import React from "react";
import Modal from "./Modal";
import { MODAL_CLOSE } from "src/constants/images";
import Spinner from "components/Loader/Spinner";

const NameModal = ({
  onChangeName,
  onClose,
  isVisible,
  onChange,
  nameChangeCost,
  name,
  onBlur,
  nameValidation,
  currentName,
  nameLoader,
  gbetInWallet,
  accumulatedGbet,
}) => {
  const onChangeNameHandler = () => {
    onChangeName();
  };

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="name-modal card px-4 py-3"
    >
      <div className="header mb-1">
        <div className=" d-flex border-0 justify-content-between mb-0 flex-row">
          <p className="mb-2">Change name</p>
          <span
            onClick={() => onClose()}
            onKeyPress={(e) => e.code == "Enter" && onClose()}
            className="close-modal"
          >
            <img src={MODAL_CLOSE.SOURCE} alt="close" />
          </span>
        </div>
        {/* <p className="text px-0">
          To change name, you need{" "}
          <strong>{Math.round(nameChangeCost)} $GBET</strong>
        </p> */}
      </div>
      <div className="nm-body">
        {/* <p>Current Name</p> */}
        <h2>{currentName}</h2>
        <div className="wallet-info pt-3 pb-3 px-2">
          <div className="mb-3">
            <span>Wallet :</span> <strong>{gbetInWallet} $GBET</strong>
          </div>
          <div>
            <span>Accumulated:</span> <strong>{accumulatedGbet} $GBET</strong>
            {/* <span
              className="mx-3 cursor-pointer"
              style={{ color: "#068385", fontSize: "14px" }}
              onClick={() => onClose()}
            >
              Claim
            </span> */}
          </div>
        </div>
        <div className="body my-2 input-group">
          <input
            type="text"
            class={`form-control ${nameValidation !== "" && "error"}`}
            id="price"
            aria-describedby="price"
            placeholder="Enter Name"
            onChange={(e) => {
              onChange(e);
            }}
            onBlur={onBlur}
            required
          />
        </div>
        <div className="change-name-cost pt-2 pb-4 px-2">
          <span>Cost : </span>
          <strong
            style={{
              color: `${
                gbetInWallet < Math.round(nameChangeCost)
                  ? "#d21b59"
                  : "var(--title)"
              }`,
            }}
          >
            {Math.round(nameChangeCost)} $GBET
          </strong>
        </div>
      </div>
      <p class="text-center text-danger">{nameValidation}</p>
      <div className="footer text-center mt-2 pb-3 position-relative">
        <button
          className="btn btn-primary"
          disabled={
            name.trim().split("").length <= 2 ||
            nameValidation != "" ||
            nameLoader ||
            gbetInWallet < Math.round(nameChangeCost)
          }
          onClick={onChangeNameHandler}
        >
          Confirm
        </button>
        {nameLoader && (
          <Spinner className="position-absolute text-primary loader" />
        )}

        <span className="helper-text text-center pt-2 d-block">
          *Character should be above 2 characters and avoid symbol(ex: #, @,$).
        </span>
      </div>
    </Modal>
  );
};

export default NameModal;
